import { ActionReducerMap } from '@ngrx/store';
import { authReducer, AuthState } from '@features/auth/store';
import { profileReducer, ProfileState } from '@features/profile/store';
import { onDemandReducer, OnDemandState } from '@features/on-demand/store';

export interface RootState {
  auth: AuthState;
  profile: ProfileState;
  onDemand: OnDemandState;
}

export const rootReducers: ActionReducerMap<RootState> = {
  auth: authReducer,
  profile: profileReducer,
  onDemand: onDemandReducer,
};
